// @flow
import * as React from 'react';
import type { LayoutProps } from './LayoutProps';

const NAV_WIDTH = 200;
const MAIN_WIDTH = 1240;

const Viewport = ({ children }: LayoutProps) => {
  if (React.Children.count(children) !== 2) {
    throw new Error('Shell component expects exactly 2 children');
  }

  const [nav, main] = React.Children.toArray(children);

  return (
    <div className="min-vh-100 min-vw-100" style={{ paddingLeft: NAV_WIDTH }}>
      <div
        className="w5 min-vh-100 fixed top-0 left-0 bottom-0 bg-dark-gray"
        style={{ width: NAV_WIDTH }}
      >
        {nav}
      </div>

      {main}
    </div>
  );
};

export const Main = ({ children }: LayoutProps) => (
  <main
    className={`db cf min-vh-100 center ph5-l ph4 `}
    style={{ maxWidth: MAIN_WIDTH }}
  >
    <div className="mv4">{children}</div>
  </main>
);

export const Header = ({ children }: LayoutProps) => (
  <div className="mv4 w-100 flex flex-row justify-between items-center">
    {children}
  </div>
);

export default Viewport;



// WEBPACK FOOTER //
// ./src/pages/__components__/Viewport.js